import { useVisualiserStore } from '@/pinia/visualiser'
import { useBrandedStore } from '@/pinia/branded'
import { useBasketStore } from '@/pinia/basket'

const routes = [
  {
    path: '/:slug/choose-product',
    name: 'Design Online - Choose Product',
    component: () => import('@/views/Branded/ChooseProduct.vue')
  },
  {
    path: '/:slug/design/:id',
    name: 'Design Online - Designer',
    component: () => import('@/views/Branded/Designer.vue')
  },
  {
    path: '/:slug/basket',
    name: 'Design Online - Basket',
    component: () => import('@/views/Branded/Basket.vue')
  },
  {
    path: '/:slug/thanks',
    name: 'Design Online - Thank You',
    component: () => import('@/views/Branded/ThankYou.vue')
  },
  {
    path: '/:slug/visualiser',
    name: 'Design Online - Visualiser Setup',
    meta: { showSidebar: false },
    component: () => import('@/views/Shared/VisualiserUpload.vue'),
    beforeEnter: (to, from, next) => {
      const basketStore = useBasketStore()
      if (basketStore.hasContract) {
        next()
      } else {
        const brandedStore = useBrandedStore()
        next({ path: `/launch/${brandedStore.slug}` })
      }
    }
  },
  {
    path: '/:slug/visualiser/place',
    name: 'Design Online - Visualiser',
    meta: { showSidebar: false },
    component: () => import('@/views/Shared/Visualiser/VisualiserPlace.vue'),
    beforeEnter: (to, from, next) => {
      const basketStore = useBasketStore()
      const brandedStore = useBrandedStore()
      if (basketStore.hasContract) {
        const visualiserStore = useVisualiserStore()
        if (visualiserStore.images.length > 0 && visualiserStore.selectedImageId) {
          next()
        } else {
          next({ path: `/${brandedStore.slug}/visualiser` })
        }
      } else {
        next({ path: `/launch/${brandedStore.slug}` })
      }
    }
  }
]

export default routes.map((route) => {
  const meta = { ...route.meta, app: 'branded' }
  return { ...route, meta }
})
